(function initEditorialHeroSection() {
  var FADE_DURATION_MS = 600;
  var SWAP_DELAY_MS = 180;

  /**
   * @typedef {Object} EditorialContentNodes
   * @property {HTMLElement | null} eyebrow
   * @property {HTMLElement | null} headline
   * @property {HTMLElement | null} ctaWrap
   * @property {HTMLAnchorElement | null} ctaLink
   * @property {HTMLElement | null} ctaLabel
   */

  function init() {
    var sections = document.querySelectorAll('.section-editorial-hero');
    if (!sections.length) return;

    sections.forEach(function (section) {
      setupSection(section);
    });
  }

  /**
   * @param {Element} section
   */
  function setupSection(section) {
    /** @type {HTMLElement} */
    var sectionElement = /** @type {HTMLElement} */ (section);

    if (sectionElement.dataset.editorialHeroInitialized === 'true') return;
    sectionElement.dataset.editorialHeroInitialized = 'true';

    /** @type {HTMLElement | null} */
    var mediaStage = section.querySelector('[data-media-stage]');
    var contentRoot = section.querySelector('[data-content-root]');
    /** @type {HTMLElement[]} */
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-thumb]'));
    var slideIntervalRaw = sectionElement.getAttribute('data-slide-interval-seconds');
    var isAutoplayEnabled = (sectionElement.getAttribute('data-enable-autoplay') || '').toLowerCase() === 'true';
    var slideIntervalSeconds = slideIntervalRaw ? Number(slideIntervalRaw) : NaN;
    var slideIntervalMs = Number.isFinite(slideIntervalSeconds) && slideIntervalSeconds > 0
      ? Math.max(Math.round(slideIntervalSeconds * 1000), FADE_DURATION_MS + 100)
      : 4000;
    if (!mediaStage) return;
    var stage = mediaStage;
    /** @type {number | null} */
    var autoRotateTimer = null;

    /** @type {EditorialContentNodes | null} */
    var contentNodes = contentRoot
      ? {
        eyebrow: contentRoot.querySelector('[data-content-eyebrow]'),
        headline: contentRoot.querySelector('[data-content-headline]'),
        ctaWrap: contentRoot.querySelector('[data-content-cta-wrap]'),
        ctaLink: /** @type {HTMLAnchorElement | null} */ (contentRoot.querySelector('[data-content-cta-link]')),
        ctaLabel: contentRoot.querySelector('[data-content-cta-label]')
      }
      : null;

    enforceAutoplayFallback(stage);

    if (!thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        handleThumbSelection(thumb, thumbs, stage, false, contentNodes);
        restartAutoRotation();
      });
    });

    var preselected = thumbs.find(function (thumb) {
      return thumb.classList.contains('is-active');
    });
    var initialThumb = preselected || thumbs[0];

    if (initialThumb) {
      handleThumbSelection(initialThumb, thumbs, stage, true, contentNodes);
    }

    if (thumbs.length > 1 && isAutoplayEnabled) {
      startAutoRotation();

      sectionElement.addEventListener('mouseenter', stopAutoRotation);
      sectionElement.addEventListener('mouseleave', startAutoRotation);
      sectionElement.addEventListener('focusin', stopAutoRotation);
      sectionElement.addEventListener('focusout', startAutoRotation);

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopAutoRotation();
          return;
        }

        startAutoRotation();
      });
    }

    function getActiveThumb() {
      return thumbs.find(function (t) { return t.classList.contains('is-active'); }) || null;
    }

    function removeSpinner(thumb) {
      if (!thumb) return;
      var existing = thumb.querySelector('.editorial-hero__spinner');
      if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
    }

    function removeAllSpinners() {
      thumbs.forEach(function (t) { removeSpinner(t); });
    }

    function startSpinner(thumb, duration) {
      if (!thumb) return;
      removeSpinner(thumb);

      var rect = thumb.getBoundingClientRect();
      var w = rect.width;
      var h = rect.height;
      if (!w || !h) return;

      var strokeWidth = 2;
      var r = 9;
      var half = strokeWidth / 2;
      var perimeter = 2 * (w - 2 * r) + 2 * (h - 2 * r) + 2 * Math.PI * r;

      var ns = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('class', 'editorial-hero__spinner');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      svg.setAttribute('width', String(w));
      svg.setAttribute('height', String(h));
      svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
      svg.style.setProperty('--spinner-duration', (duration / 1000) + 's');

      var trackEl = document.createElementNS(ns, 'rect');
      trackEl.setAttribute('x', String(half));
      trackEl.setAttribute('y', String(half));
      trackEl.setAttribute('width', String(w - strokeWidth));
      trackEl.setAttribute('height', String(h - strokeWidth));
      trackEl.setAttribute('rx', String(r));
      trackEl.setAttribute('ry', String(r));
      trackEl.setAttribute('fill', 'none');
      trackEl.setAttribute('stroke', 'rgba(255, 255, 255, 0.3)');
      trackEl.setAttribute('stroke-width', String(strokeWidth));
      trackEl.setAttribute('class', 'editorial-hero__spinner-track');

      var rectEl = document.createElementNS(ns, 'rect');
      rectEl.setAttribute('x', String(half));
      rectEl.setAttribute('y', String(half));
      rectEl.setAttribute('width', String(w - strokeWidth));
      rectEl.setAttribute('height', String(h - strokeWidth));
      rectEl.setAttribute('rx', String(r));
      rectEl.setAttribute('ry', String(r));
      rectEl.setAttribute('fill', 'none');
      rectEl.setAttribute('stroke', 'rgba(255, 255, 255, 1)');
      rectEl.setAttribute('stroke-width', String(strokeWidth));
      rectEl.setAttribute('stroke-linecap', 'round');
      rectEl.setAttribute('stroke-dasharray', String(perimeter));
      rectEl.setAttribute('stroke-dashoffset', String(perimeter));
      rectEl.setAttribute('class', 'editorial-hero__spinner-progress');

      svg.appendChild(trackEl);
      svg.appendChild(rectEl);
      thumb.appendChild(svg);
    }

    function startAutoRotation() {
      if (autoRotateTimer || thumbs.length < 2) return;

      startSpinner(getActiveThumb(), slideIntervalMs);

      autoRotateTimer = window.setInterval(function () {
        var currentIndex = thumbs.findIndex(function (item) {
          return item.classList.contains('is-active');
        });
        var safeIndex = currentIndex >= 0 ? currentIndex : 0;
        var nextIndex = (safeIndex + 1) % thumbs.length;
        var nextThumb = thumbs[nextIndex];
        if (!nextThumb) return;

        removeAllSpinners();
        handleThumbSelection(nextThumb, thumbs, stage, false, contentNodes);
        startSpinner(nextThumb, slideIntervalMs);
      }, slideIntervalMs);
    }

    function stopAutoRotation() {
      if (!autoRotateTimer) return;
      window.clearInterval(autoRotateTimer);
      autoRotateTimer = null;
      removeAllSpinners();
    }

    function restartAutoRotation() {
      stopAutoRotation();
      if (isAutoplayEnabled && thumbs.length > 1) {
        startAutoRotation();
      }
    }
  }

  /**
   * @param {HTMLElement} thumb
   * @param {HTMLElement[]} thumbs
   * @param {HTMLElement} mediaStage
   * @param {boolean} immediate
   * @param {EditorialContentNodes | null} contentNodes
   */
  function handleThumbSelection(thumb, thumbs, mediaStage, immediate, contentNodes) {
    var mediaType = (thumb.dataset.mediaType || '').trim();
    if (!mediaType) return;

    if (!immediate && mediaStage.dataset.isTransitioning === 'true') {
      return;
    }

    thumbs.forEach(function (item) {
      item.classList.toggle('is-active', item === thumb);
      item.setAttribute('aria-pressed', item === thumb ? 'true' : 'false');
    });

    var nextPayload = {
      type: mediaType,
      imageDesktop: thumb.dataset.mediaImageDesktop || '',
      imageMobile: thumb.dataset.mediaImageMobile || '',
      video: thumb.dataset.mediaVideo || '',
      videoPoster: thumb.dataset.mediaVideoPoster || '',
      slideEyebrow: thumb.dataset.slideEyebrow || '',
      slideHeadline: thumb.dataset.slideHeadline || '',
      slideCtaEnabled: (thumb.dataset.slideCtaEnabled || '').toLowerCase() === 'true',
      slideCtaLabel: thumb.dataset.slideCtaLabel || '',
      slideCtaLink: thumb.dataset.slideCtaLink || '',
      slideCtaStyle: thumb.dataset.slideCtaStyle || 'primary'
    };

    var currentVideo = mediaStage.querySelector('video');
    if (currentVideo) {
      currentVideo.pause();
    }

    if (immediate) {
      swapMedia(mediaStage, nextPayload);
      updateSlideContent(contentNodes, nextPayload);
      return;
    }

    mediaStage.dataset.isTransitioning = 'true';
    mediaStage.classList.add('is-fading');

    window.setTimeout(function () {
      swapMedia(mediaStage, nextPayload);
      updateSlideContent(contentNodes, nextPayload);
    }, SWAP_DELAY_MS);

    window.setTimeout(function () {
      mediaStage.classList.remove('is-fading');
      mediaStage.removeAttribute('data-is-transitioning');
    }, FADE_DURATION_MS);
  }

  /**
   * @param {HTMLElement} mediaStage
   * @param {{
   *  type: string,
   *  imageDesktop: string,
   *  imageMobile: string,
   *  video: string,
   *  videoPoster: string,
   *  slideEyebrow: string,
   *  slideHeadline: string,
   *  slideCtaEnabled: boolean,
   *  slideCtaLabel: string,
   *  slideCtaLink: string,
   *  slideCtaStyle: string
   * }} payload
   */
  function swapMedia(mediaStage, payload) {
    mediaStage.classList.remove('editorial-hero__media-stage--has-mobile-image');

    if (payload.type === 'video') {
      if (!payload.video || !payload.videoPoster) {
        mediaStage.innerHTML = buildImageMarkup(payload.imageDesktop || payload.videoPoster, payload.imageMobile);
        if (payload.imageMobile) {
          mediaStage.classList.add('editorial-hero__media-stage--has-mobile-image');
        }
        return;
      }

      mediaStage.innerHTML = buildVideoMarkup(payload.video, payload.videoPoster);
      enforceAutoplayFallback(mediaStage);
      return;
    }

    if (!payload.imageDesktop) {
      mediaStage.innerHTML = '<div class="editorial-hero__media editorial-hero__media--placeholder"></div>';
      return;
    }

    mediaStage.innerHTML = buildImageMarkup(payload.imageDesktop, payload.imageMobile);
    if (payload.imageMobile) {
      mediaStage.classList.add('editorial-hero__media-stage--has-mobile-image');
    }
  }

  /**
   * @param {EditorialContentNodes | null} contentNodes
   * @param {{
   *  slideEyebrow: string,
   *  slideHeadline: string,
   *  slideCtaEnabled: boolean,
   *  slideCtaLabel: string,
   *  slideCtaLink: string,
   *  slideCtaStyle: string
   * }} payload
   */
  function updateSlideContent(contentNodes, payload) {
    if (!contentNodes) return;

    if (contentNodes.eyebrow) {
      contentNodes.eyebrow.textContent = payload.slideEyebrow || '';
      contentNodes.eyebrow.classList.toggle('is-hidden', !payload.slideEyebrow);
    }

    if (contentNodes.headline) {
      contentNodes.headline.innerHTML = payload.slideHeadline || '';
      contentNodes.headline.classList.toggle('is-hidden', !payload.slideHeadline);
    }

    var showSlideCta = payload.slideCtaEnabled && payload.slideCtaLabel;

    if (contentNodes.ctaWrap) {
      contentNodes.ctaWrap.classList.toggle('is-hidden', !showSlideCta);
    }

    if (showSlideCta && contentNodes.ctaLink && contentNodes.ctaLabel) {
      contentNodes.ctaLabel.textContent = payload.slideCtaLabel;
      contentNodes.ctaLink.setAttribute('href', payload.slideCtaLink || '#');
      contentNodes.ctaLink.classList.remove('editorial-hero__cta--primary', 'editorial-hero__cta--secondary');
      contentNodes.ctaLink.classList.add('editorial-hero__cta--' + (payload.slideCtaStyle || 'primary'));
    }
  }

  /**
   * @param {string} desktopSrc
   * @param {string} mobileSrc
   */
  function buildImageMarkup(desktopSrc, mobileSrc) {
    var mobileMarkup = mobileSrc
      ? '<img class="editorial-hero__media editorial-hero__media--image-mobile" src="' + escapeHtml(mobileSrc) + '" alt="" loading="lazy">'
      : '';

    return (
      '<img class="editorial-hero__media editorial-hero__media--image-desktop" src="' + escapeHtml(desktopSrc) + '" alt="" loading="lazy">' +
      mobileMarkup
    );
  }

  /**
   * @param {string} videoSrc
   * @param {string} posterSrc
   */
  function buildVideoMarkup(videoSrc, posterSrc) {
    return (
      '<video class="editorial-hero__media editorial-hero__media--video" autoplay muted loop playsinline preload="metadata" poster="' + escapeHtml(posterSrc) + '">' +
      '<source src="' + escapeHtml(videoSrc) + '" type="video/mp4">' +
      '</video>'
    );
  }

  /**
   * @param {HTMLElement} mediaStage
   */
  function enforceAutoplayFallback(mediaStage) {
    var video = mediaStage.querySelector('video');
    if (!video) return;
    var safeVideo = video;

    var attempt = safeVideo.play();
    if (!attempt || typeof attempt.catch !== 'function') return;

    attempt.catch(function () {
      var poster = safeVideo.getAttribute('poster');
      if (!poster) return;

      mediaStage.innerHTML =
        '<img class="editorial-hero__media editorial-hero__media--image-desktop" src="' + escapeHtml(poster) + '" alt="" loading="lazy">';
    });
  }

  /**
   * @param {string} value
   */
  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target instanceof Element ? event.target : null;
    if (!section || !section.matches('.section-editorial-hero')) return;
    setupSection(section);
  });
})();
